/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Printing_The_PressInputs */

const en_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printing the Press...`)
};

const es_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimiendo...`)
};

const fr_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impression en cours...`)
};

const de_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gedruckt...`)
};

const ja_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印刷中...`)
};

const zh_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在付印...`)
};

const ar_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري الطباعة...`)
};

const id_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencetak...`)
};

const it_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stampa in corso...`)
};

const ru_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Печать в процессе...`)
};

const pt_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A imprimir...`)
};

const ko_printing_the_press = /** @type {(inputs: Printing_The_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인쇄 중...`)
};

/**
* | output |
* | --- |
* | "Printing the Press..." |
*
* @param {Printing_The_PressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const printing_the_press = /** @type {((inputs?: Printing_The_PressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Printing_The_PressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_printing_the_press(inputs)
	if (locale === "es") return es_printing_the_press(inputs)
	if (locale === "fr") return fr_printing_the_press(inputs)
	if (locale === "de") return de_printing_the_press(inputs)
	if (locale === "ja") return ja_printing_the_press(inputs)
	if (locale === "zh") return zh_printing_the_press(inputs)
	if (locale === "ar") return ar_printing_the_press(inputs)
	if (locale === "id") return id_printing_the_press(inputs)
	if (locale === "it") return it_printing_the_press(inputs)
	if (locale === "ru") return ru_printing_the_press(inputs)
	if (locale === "pt") return pt_printing_the_press(inputs)
	return ko_printing_the_press(inputs)
});